<div class="container-fluid mt-5 b_shadow">
  <div class="row">
    <div class="col-sm-12 col-12 col-md-12 col-lg-12 header create-header bg-infos">Create new ACH</div>

  </div>
      <ng-container *ngIf="topErrorMsg">

        <div class="col-md-12" >
          <p class="col-md-12 error" id="err">{{topErrorMsg}}</p>
        </div>
        <div class="row err" *ngFor="let obj of keys1 ">
          <div class="col-md-12" *ngFor="let value of obj ">
            <p class="col-md-12 error" id="err">{{value}}</p>
          </div>
        </div>
      </ng-container>
      <div class="row" *ngIf="!topErrorMsg">
        <div class="col-md-12 error "> {{errorMsg}}</div>
      </div>
  <div class="col-lg-9 col-sm-12 col-12 col-md-12 col-xl-8 pt-4">
  <form [formGroup]="achForm" #achFormF="ngForm">

    <div class="col-md-12">

        <div class="form-group row">
          <label for="currency" class="col-xl-4 col-lg-4 col-md-4 col-12 pr-0">Currency:<i
            class="required-icon">*</i></label>
          <span class="error_sign" id="currency1">!</span>
          <div class="col-xl-7 col-lg-7 col-md-7 col-12 mob_fields">
            <select class="form-control" id="currency" name="currency"
                    [class.invalid]="achForm.controls['currencyInput'].invalid && achFormF.submitted"
                    formControlName="currencyInput" [(ngModel)]="achcharge.currency">

              <option *ngFor="let currency of currencies" [attr.selected]="achcharge.currency === currency.name"
                      [value]="currency.name">{{currency.name}}</option>
            </select>
            <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && achForm.controls['currencyInput'].invalid">Currency is required.</span>
          </div>
        </div>
        <div class="form-group row">
          <label
            class="col-xl-4 col-lg-4 col-md-4 col-12 pr-0"> Amount
            :<i
              class="required-icon">*</i></label>
          <span class="error_sign" id="amount1">!</span>
          <div class="col-xl-7 col-lg-7 col-md-7 col-11 mob_fields">
            <input class="form-control amountInput" id="amount" name="amount"
                    [class.invalid]="achForm.controls['amount'].invalid && achFormF.submitted" appMinMaxValidator
                    appAmountValidator min="0.01" max="9999999" type="number" formControlName="amount"
                    autocomplete="off"
                    [(ngModel)]="achcharge.amount " step="0.01" (keyup)="minMaxCheck(achcharge.amount)"
                    (change)="checkAmount()" (keypress)="_keyPress($event)" placeholder="0.00"/>
            <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && achForm.controls['amount'].errors?.required">Amount is required.</span>
            <span class="validation-err-msg"
                  *ngIf="!achForm.controls['amount'].errors?.required && minError === true">Amount should not be less than $0.5.</span>

          </div>
          <ng-template #amountInpTemplate>
            <div class="text-left">
              <b>Description: </b>The amount to be processed and includes the subtotal and any additional achcharges.

              If a request transaction amount includes a decimal point, the response will also include a decimal
              point.

              For void and return transactions, this is a conditional field. If this is not included in the request,
              then
              the full amount of the original transaction is voided.<br>
            </div>
          </ng-template>
          <div class="col-1 pl-0 pt-1"><i [appTooltip]="amountInpTemplate" appTooltipPlacement="left"
                                          class="fa pointer fa-lg fa-question-circle"></i></div>
        </div>
        <div class="form-group row">
          <label class="col-xl-4 col-lg-4 col-md-4 col-12 pr-0">Account Number:<i class="required-icon">*</i></label>
          <span class="error_sign" id="account_number1">!</span>
          <div class="col-xl-7 col-lg-7 col-md-7 col-12 mob_fields">
            <input class="form-control account-text" value="" name="account_number" id="account_number"
                    [class.invalid]="achForm.controls['accountNumber'].invalid && achFormF.submitted"
                    autocomplete="cc-number" (keypress)="_keyPress($event)" type="text" credit-card
                    placeholder="•••• •••• •••• ••••" [(ngModel)]="bank_account.bank_account_number"
                    formControlName="accountNumber" maxlength="17">

            <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && achForm.controls['accountNumber'].errors?.required">Account number is
                  required.</span>
            <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && !achForm.controls['accountNumber'].errors?.required && achForm.controls['accountNumber'].invalid">Account
                  number is invalid.</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-4 col-lg-4 col-md-4 col-12 pr-0">Routing Number:<i class="required-icon">*</i></label>
          <span class="error_sign" id="routing_number1">!</span>
          <div class="col-xl-7 col-lg-7 col-md-7 col-12 mob_fields">
            <input class="form-control account-text" value="" name="routing_number" id="routing_number"
                    [class.invalid]="achForm.controls['routingNumber'].invalid && achFormF.submitted"
                    autocomplete="cc-number" (keypress)="_keyPress($event)" type="text" credit-card
                    placeholder="•••• •••• •••• •"
                    formControlName="routingNumber" maxlength="9">

            <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && achForm.controls['routingNumber'].errors?.required">Routing number is
                  required.</span>
            <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && !achForm.controls['routingNumber'].errors?.required && achForm.controls['routingNumber'].invalid">Routing
                  number is invalid.</span>
          </div>
        </div>
        <div class="form-group row  ">
          <label for="transaction_type" class="col-xl-4 col-lg-4 col-md-4 col-12 pr-0">Transaction Type:<i class="required-icon" >*</i>
          </label>
          <div class="col-xl-7 col-lg-7 col-md-7 col-12 mob_fields">
            <select class="form-control col-xl-12 col-lg-12 col-md-12 col-sm-8 col-12  " formControlName="transaction_type"
            [class.invalid]="achForm.controls['transaction_type'].invalid && achFormF.submitted"
                    id="transaction_type"
                    name="transaction_type"
                    [(ngModel)]="bank_account.transaction_type" required>
              <option *ngFor="let type of list_transaction_types" [ngValue]="type.ABBR">{{type.value}}</option>
            </select>
            <!-- <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && achForm.controls['transaction_type'].errors?.required">Transaction Type is required.</span>
            <span class="validation-err-msg"
                  *ngIf="achFormF.submitted && !achForm.controls['transaction_type'].errors?.required && achForm.controls['transaction_type'].invalid">Transaction Type is invalid.</span> -->
          </div>
        </div>





        <div class="row justify-content-end px-4 py-4">
          <button (click)="cancelBtn()" class="cancel_btn">Cancel</button>
          <app-loading-button   (buttonClick)="createAchDirectTransaction()"
                              class="float-left" [loadFlag]="loadFlag" type="submit"
                              [buttonText]="'Create payment'"></app-loading-button>

      </div>
    </div>
  </form>
  </div>
  </div>

